import {useEffect} from 'react';
import logCenter from '@deezer/next/services/tracking/LogCenter';
import type {CustomAttributesType} from '@deezer/next/services/tracking/LogCenter/events/utlis';
import {getScreenViewEvent} from '@deezer/next/services/tracking/LogCenter/events/utlis';
import type {ScreenViewName} from '@deezer/next/services/tracking/LogCenter/events/types';

const useScreenViewEvent = (
	callback: () => {
		screenName: ScreenViewName;
		customAttributes?: CustomAttributesType | undefined;
	},
	deps?: any[] | undefined,
) => {
	useEffect(() => {
		const {screenName, customAttributes} = callback();
		logCenter.log(getScreenViewEvent(screenName, customAttributes));
	}, deps);
};

export default useScreenViewEvent;
